import { Controller } from "react-hook-form";
import { RecipePicker } from "./RecipePicker";

export const ControlledRecipePicker = ({
    name,
    label,
    modalTitle,
    errors,
    isLoading,
    items,
    labelSelector,
    valueSelector,
    control,
    className,
    onChange,
}: {
    name: string;
    label: string;
    modalTitle: string;
    errors: any;
    isLoading: boolean;
    items: any[];
    labelSelector?: (x: any) => string;
    valueSelector?: (x: any) => any;
    control: any;
    className?: string;
    onChange?: (e: any) => void;
}) => {
    return (
        <Controller
            key={name}
            name={name}
            control={control}
            render={({ field }) => (
                <RecipePicker
                    {...field}
                    label={label}
                    modalTitle={modalTitle}
                    name={name}
                    errors={errors}
                    isLoading={isLoading}
                    items={items}
                    className={className}
                    labelSelector={labelSelector || ((x) => x.name)}
                    valueSelector={valueSelector || ((x) => x.id)}
                    onChange={(e) => {
                        onChange && onChange(e);
                        field.onChange(e);
                    }}
                />
            )}
        />
    );
};
